// extracted by mini-css-extract-plugin
export default {"rotate":"Loader_rotate__NEbL0","reverse":"Loader_reverse__edr1F"};